import React, { useState } from 'react'
import clipboard from '../images/Online Clipboard App Design.png'
import Navbar from './Navbar'
import Sidebar from './Sidebar'
import RespSidebar from './RespSidebar'
import githubIcon from '../images/github (1).png'
import webIcon from '../images/earth (1).png'
import onlinequizimage from '../images/Online quiz application.png'
import researchPaperImage from '../images/research-paper-card-v2.png'

export default function Projects() {
  const [Drop, setDrop] = useState(false)
  const stackofproject1 = ["Spring Boot", "MySQL", "Docker", "React", "Jenkins"]
  const stackofproject2 = ["Next", "Spring Boot", "MySQL","Docker","Jenkins","Kubernetes"]
  const stackofproject3 = ["IEEE Xplore", "Research Paper", "Deep Learning", "Machine Learning"]
  return (
    <div>
        
        <main>
        {Drop ? <RespSidebar setDropDown={setDrop}/> :  <Sidebar setDropDown={setDrop}/>}

  <div className="main-content">
    <Navbar link="projects"/>
    
   
    <article
      className="portfolio active"
      data-page="portfolio"
    >
      
        <header>
          <h2 className="h2 article-title typing-text">
            Projects
          </h2>
        </header>
     
      <section className="projects">
        <ul className="project-list">
          <li
            className="project-item active shadow-lg rounded-lg p-4"
            data-category="Research"
            data-filter-item=""
          >
            <img
              className='rounded-xl'
              alt="Research Paper"
              loading="lazy"
              src={researchPaperImage}
            />
              
              <h3 className="project-title m-4 text-center">
               Research Paper
              </h3>
              <p className="project-category" />
              <div className='flex flex-wrap m-1 mb-4 '>
                 {stackofproject3.map((item)=>(
                  <div key={item} className="text-xs px-2 m-1 py-0.5 rounded-full bg-green-500/10 text-green-400">
                    {item}
                  </div>
                 ))}
              </div>
          <div className='flex justify-evenly'>
            <a
              className='text-spring '
              href="https://github.com/Ujwal-Hiranwar/pneumonia-detection-from-chest-x-ray"
              target='_blank'
              rel="noreferrer"
              style={{
                animation: 'blink 1s infinite',
                border: '2px solid green',
                color: 'white',
                display: 'flex',
                fontSize: '12px',
                fontWeight: 'bold',
                borderRadius : '10px',
                padding: '7px 16px',
                textDecoration: 'none',
                transition: 'background-color 0.3s, color 0.3s, border-color 0.3s'
              }}
            >
              <img src={githubIcon} className="mr-2.5 service-item-text" height={20} width={20} alt="" />
              Code 
            </a>
            <a
              className='text-spring '
              href="https://ieeexplore.ieee.org/document/11377409"
              target='_blank'
              rel="noreferrer"
              style={{
                animation: 'blink 1s infinite',
                border: '2px solid green',
                color: 'white',
                display: 'flex',
                fontSize: '12px',
                fontWeight: 'bold',
                borderRadius : '10px',
                padding: '7px 16px',
                textDecoration: 'none',
                transition: 'background-color 0.3s, color 0.3s, border-color 0.3s'
              }}
            >
              <img src={webIcon} className='mr-2.5 service-item-text' height={20} width={20} alt="" />
              Paper
            </a>
            </div>
          </li>       
          <li
            className="project-item active shadow-lg rounded-lg p-4"
            data-category="Video Edito"
            data-filter-item=""
          >
                <img
                className='rounded-xl'
                  alt="finance"
                  loading="lazy"
                  src={clipboard}
                />
              
              <h3 className="project-title m-4 text-center">
               Instant Data Transfer App
              </h3>
              <p className="project-category" />
              <div className='flex flex-wrap m-1 mb-4 '>
                 {stackofproject2.map((item)=>(
                  <div key={item} className="text-xs px-2 m-1 py-0.5 rounded-full bg-green-500/10 text-green-400">
                                  {item}
                                </div>
                 ))}
                              
                                

              </div>
          <div className='flex justify-evenly'>
            <a
            className='text-spring '
              href="https://github.com/Ujwal-Hiranwar/online-clipboard-app"
              target='_blank'
              rel="noreferrer"
              style={{
                animation: 'blink 1s infinite',
                border: '2px solid green',
                color: 'white',
                display: 'flex',
                fontSize: '12px',
                fontWeight: 'bold',
                borderRadius : '10px',
                padding: '7px 16px',
                textDecoration: 'none',
                transition: 'background-color 0.3s, color 0.3s, border-color 0.3s'
              }}
              
            >
              <img src={githubIcon} className="mr-2.5 service-item-text" height={20} width={20} alt="" />
              Code 
            </a><a
            className='text-spring '
              href="https://foryouclipboardapp.vercel.app/"
              target='_blank'
              rel="noreferrer"
              style={{
                animation: 'blink 1s infinite',
                border: '2px solid green',
                color: 'white',
                display: 'flex',
                fontSize: '12px',
                fontWeight: 'bold',
                borderRadius : '10px',
                padding: '7px 16px',
                textDecoration: 'none',
                transition: 'background-color 0.3s, color 0.3s, border-color 0.3s'
              }}
              
            >
              <img src={webIcon} className='mr-2.5 service-item-text' height={20} width={20} alt="" />
              Demo
            </a>
            </div>
          </li>
          <li
            className="project-item active shadow-lg rounded-lg p-4"
            data-category="Video Edito"
            data-filter-item=""
          >
                <img
                className='rounded-xl' 
                  alt="finance"
                  loading="lazy"
                  src={onlinequizimage}
                />
              
              <h3 className="project-title m-4 text-center">
               Online Quiz Application
              </h3>
              <p className="project-category" />
              <div className='flex flex-wrap m-1 mb-4 '>
                 {stackofproject1.map((item)=>(
                                <div key={item} className="text-xs px-2 py-0.5 m-1 rounded-full bg-green-500/10 text-green-400">
                                  {item}
                                </div>
                 )
                
                )}
              </div>
          <div className='flex justify-evenly'>
            <a
            className='text-spring '
              href="https://github.com/Ujwal-Hiranwar/online-quiz-app"
              target='_blank'
              rel="noreferrer"
              style={{
                animation: 'blink 1s infinite',
                border: '2px solid green',
                color: 'white',
                display: 'flex',
                fontSize: '12px',
                fontWeight: 'bold',
                borderRadius : '10px',
                padding: '7px 16px',
                textDecoration: 'none',
                transition: 'background-color 0.3s, color 0.3s, border-color 0.3s'
              }}
              
            >
              <img src={githubIcon} className="mr-2.5 service-item-text" height={20} width={20} alt="" />
              Code 
            </a><a
            className='text-spring '
              href="https://online-quizz-frontend.vercel.app/"
              target='_blank'
              rel="noreferrer"
              style={{
                animation: 'blink 1s infinite',
                border: '2px solid green',
                color: 'white',
                display: 'flex',
                fontSize: '12px',
                fontWeight: 'bold',
                borderRadius : '10px',
                padding: '7px 16px',
                textDecoration: 'none',
                transition: 'background-color 0.3s, color 0.3s, border-color 0.3s'
              }}
              
            >
              <img src={webIcon} className='mr-2.5 service-item-text' height={20} width={20} alt="" />
              Demo
            </a>
            </div>
          </li>

        </ul>
      </section>
    </article>
   
  </div>
</main>
    </div>
    
  )
}
